import { useState } from "react";

// import { Carousel, Image } from 'react-bootstrap';
import { Carousel, Image } from "antd";

function Slider({ allImages, height }) {
  const [selectedImage, setSelectedImage] = useState(0);

  // useEffect(() => {
  //     setInterval(() => {
  //         setSelectedImage(selectedImage => selectedImage > 1 ? 0 : selectedImage + 1)
  //     }, 2500);
  // }, [])

  return (
    <div className="carousel-section">
      <Carousel autoplay autoplaySpeed={2500}>
        {allImages.map((item, index) => (
          <Image
            src={item}
            key={index}
            width={"100%"}
            height={height}
            alt={"ImagePlaceholder" + index}
          />
        ))}
        {/* </Carousel.Item> */}
      </Carousel>
    </div>
  );
}
export default Slider;
